import { render, staticRenderFns } from "./ViolationDeleteAnswerOk.vue?vue&type=template&id=c4414f42&"
import script from "./ViolationDeleteAnswerOk.vue?vue&type=script&lang=ts&"
export * from "./ViolationDeleteAnswerOk.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports